import { render, staticRenderFns } from "./GroupedItem.vue?vue&type=template&id=4a6611a7&"
import script from "./GroupedItem.vue?vue&type=script&lang=js&"
export * from "./GroupedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports